import {useQuery} from "react-query";
import {http} from "@firefly/fly-http";



export interface UseVerifyUserMobilePrepareQueryType {
    isPrepareLoading: boolean;
    prepare: {
        mobile: string
    }
}
export default function useVerifyUserMobilePrepareQuery(userid: string | undefined): UseVerifyUserMobilePrepareQueryType {
    const {
        isLoading: isPrepareLoading,
        data: prepare
    } = useQuery({
        queryKey: ['verify-mobile', userid, "prepare"],
        queryFn: () => {
            return http.get("/api/wangame/viewer/verify-user-mobile/prepare", {
                userid: userid
            })
        },
        enabled: !!userid
    })
    return {
        isPrepareLoading,
        prepare
    }
}